import {css, StyleSheet} from "aphrodite";
import React, {useEffect, useState} from 'react';
import Config from "./config/Config";
import Analytics from "./components/containers/Analytics";
import CookiesHelper from "./utils/CookiesHelper";
import CookieBar from "./components/CookieBar";
import GridStyle from "./styles/styles";
import Header from "./components/Header";
import {setMobile} from "./actions/styles.creator";
import {useDispatch} from "react-redux";
import MediaQuery from "./styles/MediaQuery";
import Footer from "./components/Footer";
import PageContent from "./components/containers/PageContent";

const App = () => {
    const dispatch = useDispatch(),
        [gdp, setGdp] = useState(!CookiesHelper.getCookie(Config.resources.GDP_COOKIE)),
        styles = StyleSheet.create({
            container: {
                ...GridStyle.define("70px max-content max-content", "auto"),
                width: "-webkit-fill-available",
                fontFamily: Config.fonts.MAIN,
                ...MediaQuery.mobile({
                    ...GridStyle.define("60px max-content max-content", "auto"),
                })
            },
            header: GridStyle.setRowCol(1, 1),
            pageContent: GridStyle.setRowCol(2, 1),
            footer: GridStyle.setRowCol(3, 1)
        });

    useEffect(() => {
        setDocumentTitle();
        setFavicon();
        setGAHeader();
        window.matchMedia(`screen and (max-width: ${Config.styles.MEDIA_QUERY_MOBILE}px)`).addListener(mobileChange);
        return () => window.matchMedia(`screen and (max-width: ${Config.styles.MEDIA_QUERY_MOBILE}px)`).removeListener(mobileChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function mobileChange(e) {
        dispatch(setMobile({isMobile: e.matches}));
    }

    function setDocumentTitle() {
        document.title = Config.messages.tabTitle;
    }


    function setFavicon() {
        let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = Config.images.FAVICON;
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    function setGAHeader() {
        let script = document.createElement('script'),
            head = document.getElementsByTagName('head')[0];

        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','${Config.resources.GA_HEAD}');`;

        head.appendChild(script);
    }

    function gdpAccepted() {
        CookiesHelper.setCookie(Config.resources.GDP_COOKIE, true, Number.MAX_SAFE_INTEGER);
        setGdp(false);
    }


    return (
        <React.Fragment>
            <Analytics/>
            <div className={css(styles.container)}>
                <Header extraStyle={styles.header}/>
                <PageContent extraStyle={styles.pageContent}/>
                <Footer extraStyle={styles.footer}/>
                {gdp && <CookieBar onAccept={gdpAccepted}/>}
            </div>
        </React.Fragment>
    );
};

export default App;
